import { useEffect, useRef } from 'react';

/**
 * Textarea element does not resize itself based on the content length.
 * This is a workaround to set the height based on the scrollHeight
 * Takes in an array of dependencies that trigger a layout effect
 */
export const useAutoSizingTextareaRef = (deps: ReadonlyArray<any> = []) => {
    const textAreaElementRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (textAreaElementRef.current) {
            textAreaElementRef.current.style.height = `${textAreaElementRef.current.scrollHeight}px`;
        }
    }, deps);

    return textAreaElementRef;
};
